import React, { useContext } from 'react';
import { ForgeButton, ForgePageState } from '@tylertech/forge-react';
import { useNavigate } from 'react-router';
import { messageManager } from '../../../System/messageManager/messageManager.js';
import { NO_BUDGET_AVAILABLE } from '../../../../static/constants.js';
import { NAVIGATION_PATHS } from '../../../../static/navigationPaths.js';
import { useUser } from '../../../../contexts/userContext.js';
import { Context } from '../../../../store/Store.js';
import { buildPath } from '../../../../services/navigateService.js';
import { useNameConventions } from '../../../../contexts/nameConventionsContext.js';
import { LoaderContext } from '../../../../contexts/loaderContext.js';

const NoBudgetEmptyState = () => {
  const [state] = useContext(Context);
  const { nameConventions } = useNameConventions();
  const { costModel, user } = useUser();
  const { loading } = useContext(LoaderContext);
  const navigate = useNavigate();

  const generateButtonTitle = () => {
    if (!costModel) {
      return messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.BUTTON.NO_ORG_HIERARCHY;
    } else {
      return messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.BUTTON.NO_BUDGET;
    }
  };
  const generateTitle = () => {
    if (!costModel) {
      return messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.TITLE.NO_ORG_HIERARCHY;
    } else {
      return messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.TITLE.NO_BUDGET;
    }
  };

  const generateMessage = () => {
    if (!costModel) {
      return messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.MESSAGE.NO_ORG_HIERARCHY;
    } else {
      return messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.MESSAGE.NO_BUDGET;
    }
  };

  const handleClick = (buttonTitle) => {
    let path;

    if (buttonTitle === messageManager(nameConventions).NO_BUDGET_EMPTY_STATE.BUTTON.NO_ORG_HIERARCHY) {
      path = state.fireUnsavedChangesDialog || state.changesWereMade ? null : buildPath(user, NAVIGATION_PATHS.ORGANIZATIONAL_HIERARCHY);
      navigate(path);
      return;
    }
    path = state.fireUnsavedChangesDialog || state.changesWereMade ? null : buildPath(user, NAVIGATION_PATHS.BUDGET_SUMMARY);
    navigate(path, { state: { from: 'noBudgetEmptyState' } });
  };

  if (loading) return null;

  return (
    <div style={{ width: '80%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <ForgePageState>
        <img
          slot="graphic"
          src={NO_BUDGET_AVAILABLE.source}
          alt={NO_BUDGET_AVAILABLE.alt}
        />

        <p slot="title">{generateTitle()}</p>
        <p slot="message">{generateMessage()}</p>
        <ForgeButton variant="raised" slot="action" onClick={() => handleClick(generateButtonTitle())}>
          {generateButtonTitle()}
        </ForgeButton>
      </ForgePageState>
    </div>
  );
};

export default NoBudgetEmptyState;
